<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { sellertypeService } from "../../../../../services/settingservice/configurationservice/sellertype.service";
// import { settingService } from "../../../../services/settingservice/setting.service";
import List from "../../../../../components/list";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Seller Type List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      sellerTypeList: {},

      fetchingStats: false,
      title: "Seller Type List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      sellertypeService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.sellerTypeList = response;
        });
    },

    deleted: function(id) {
      sellertypeService.remove(id)
        .then(response => {
        
          // this.sellerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-seller-type-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-seller-type-add'}" :title="$t('setting.configuration.seller-type.text')" />
    <List v-bind:dataList="sellerTypeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[`name: ${$t('setting.configuration.seller-type.name')}`, 
            `name_en: ${$t('setting.configuration.seller-type.name-en')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-seller-type-edit'}"
          v-bind:filter="{
            search: ['seller_types.name', 'seller_types.name_en'],
            dropdown: []

          }"
          
    />      
  </Layout>
</template>